<div *ngIf="hasSharing" class="share-invite-modal">
  <div class="container">
    <!-- Header -->
    <div class="header-title">
      <h2 *ngIf="modalTitle" class="title">{{ modalTitle }}</h2>
      <button mat-icon-button class="close-btn" (click)="close()">
        <mat-icon fontSet="material-icons-outlined">close</mat-icon>
      </button>
    </div>

    <!-- Content -->
    <div class="content">
      <p class="message" [innerHTML]="modalDescription">
      </p>
    </div>

    <!-- Footer Actions -->
    <div class="actions">
      <button class="def-button" (click)="onShare()">
        {{ modalButton }}
      </button>
    </div>
  </div>
</div>